/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class ObjectStoreExclusionRule {
  /**
  * The id of the exclusion rule
  */
  'id': string;
  /**
  * The name of the bucket
  */
  'bucket': string;
  /**
  * On include objects modified after this date, on exclude objects modified before this date
  */
  'modificationDate'?: Date | null;
  /**
  * Objects starting with this prefix
  */
  'bucketPrefix'?: string;
  /**
  * Detrains if the rule is to include object or to exclude object (by default)
  */
  'include'?: boolean;
  /**
  * The type of the object store (e.g. S3, GCS, etc.)
  */
  'storeType': ObjectStoreExclusionRuleStoreTypeEnum;
  /**
  * How bucketPrefix is interpreted
  */
  'matchType'?: ObjectStoreExclusionRuleMatchTypeEnum;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": ""
    },
    {
      "name": "bucket",
      "baseName": "bucket",
      "type": "string",
      "format": ""
    },
    {
      "name": "modificationDate",
      "baseName": "modificationDate",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "bucketPrefix",
      "baseName": "bucketPrefix",
      "type": "string",
      "format": ""
    },
    {
      "name": "include",
      "baseName": "include",
      "type": "boolean",
      "format": ""
    },
    {
      "name": "storeType",
      "baseName": "storeType",
      "type": "ObjectStoreExclusionRuleStoreTypeEnum",
      "format": ""
    },
    {
      "name": "matchType",
      "baseName": "matchType",
      "type": "ObjectStoreExclusionRuleMatchTypeEnum",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ObjectStoreExclusionRule.attributeTypeMap;
  }

  public constructor() {
  }
}


export enum ObjectStoreExclusionRuleStoreTypeEnum {
  S3 = 'S3',
  Gcs = 'GCS'
}
export enum ObjectStoreExclusionRuleMatchTypeEnum {
  Prefix = 'prefix',
  Regex = 'regex'
}

